import Button from "../../../../../components/Button/Button";
import AddIcon from "../../../../../assets/svg/add-icon";
import { CrmViewSelectorDropdown } from "./CrmViewSelectorDropdown";
import UserManagementIcon from "../../../../../assets/svg/user-management-icon";
import ArchiveIcon from "../../../../../assets/svg/archive-icon";
import UploadLeadsIcon from "../../../../../assets/svg/upload-leads-icon";
import type { CrmViewItem } from "../../../../../redux/slices/crmLeadListSlice";

interface TabItem {
  key: string;
  label: string;
}

export const KanbanActionBar = ({
  activeTab,
  onTabChange,
  tabs,
  onCreateClick,
  viewTabs,
  editColumnsButton,
  viewToggle,
  crmViews,
  selectedViewId,
  onSelectView,
}: {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: TabItem[];
  onCreateClick?: () => void;
  viewTabs?: React.ReactNode;
  editColumnsButton?: React.ReactNode;
  viewToggle?: React.ReactNode;
  crmViews?: CrmViewItem[];
  selectedViewId?: string;
  onSelectView?: (viewId: string) => void;
}) => {
  return (
    <div className="flex flex-col gap-3 shrink-0">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button
            innerText="Create Lead"
            Icon={AddIcon}
            iconLeft={true}
            onClick={onCreateClick}
            buttonContainerClass="min-h-[26px] px-6 py-1 bg-verba-blue dark:bg-verba-blue-dk rounded-[6px]"
            innerTextClass="text-md font-semibold text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk whitespace-nowrap"
            iconClass="w-[18px] h-[18px] text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk"
          />
          {/* <Button
            innerText="Import Contacts"
            Icon={UploadLeadsIcon}
            iconLeft={true}
            buttonContainerClass="min-h-[26px] px-6 py-1 rounded-[6px] border border-verba-blue dark:border-verba-blue-dk hover:bg-applied-filters-tag-bg dark:hover:bg-applied-filters-tag-bg-dk"
            innerTextClass="text-md font-semibold text-verba-blue dark:text-verba-blue-dk whitespace-nowrap"
            iconClass="w-[12px] h-[12px] text-verba-blue dark:text-verba-blue-dk"
          /> */}
          <div className="w-px h-[16px] bg-border-gray dark:bg-border-gray-dk shrink-0" />
          {/* <Button
            innerText="All Contacts"
            Icon={UserManagementIcon}
            iconLeft={true}
            onClick={() => onTabChange("all")}
            buttonContainerClass={`min-h-[26px] px-6 py-1 rounded-[6px] border ${
              activeTab === "all"
                ? "bg-card-highlight-2 dark:bg-card-highlight-2-dk border-crm-card-border dark:border-crm-card-border-dk"
                : "border-verba-blue dark:border-verba-blue-dk hover:bg-applied-filters-tag-bg dark:hover:bg-applied-filters-tag-bg-dk"
            }`}
            innerTextClass={`text-md font-semibold whitespace-nowrap text-verba-blue dark:text-verba-blue-dk`}
            iconClass={`w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk`}
          /> */}
          {editColumnsButton}
          {/* <Button
            innerText="Import History"
            Icon={ArchiveIcon}
            iconLeft={true}
            buttonContainerClass="min-h-[26px] px-6 py-1 rounded-[6px] border border-border-gray dark:border-border-gray-dk hover:bg-applied-filters-tag-bg dark:hover:bg-applied-filters-tag-bg-dk"
            innerTextClass="text-md font-semibold text-heading-text dark:text-heading-text-dk whitespace-nowrap"
            iconClass="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk"
          /> */}
        </div>
        <CrmViewSelectorDropdown
          crmViews={crmViews}
          selectedViewId={selectedViewId}
          onSelectView={onSelectView}
        />
      </div>

      <div className="flex items-center gap-3">
        {viewTabs && (
          <div
            className="flex items-center gap-1 min-w-0 max-w-[85%] overflow-x-auto scrollbar-hide"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            <div className="flex items-center gap-[6px] shrink-0">
              {tabs?.map((tab) => {
                const isActive =
                  activeTab === tab.key &&
                  (!selectedViewId || selectedViewId === "all_leads");
                return (
                  <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={`min-h-[26px] px-5 py-1 flex items-center justify-center rounded-[6px] text-sm font-normal text-verba-indigo dark:text-verba-indigo-dk whitespace-nowrap border ${
                      isActive
                        ? "bg-card-highlight-2 dark:bg-card-highlight-2-dk border-crm-card-border dark:border-crm-card-border-dk"
                        : "border-border-gray dark:border-border-gray-dk"
                    }`}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>
            {viewTabs}
          </div>
        )}
        <div className="flex items-center gap-3 shrink-0 ml-auto">
          {viewToggle}
        </div>
      </div>
    </div>
  );
};
